module.exports = __webpack_public_path__ + "static/media/axit.7dd213d1.png";